// extracted by mini-css-extract-plugin
export default {"wrapper":"a1-z","play":"b1-z"};